import React from 'react';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

import { LabelTransport } from './LabelTransport';

export const TransportVisual = ({properties}) => {

  const styles = {
    container: {
      display: 'flex',
      width: '100%',
    },
    contentContainer: { 
      display: 'flex', 
      width: '100%', 
    },
    labelContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    },
    transportContainer: {
      display: 'flex',
      width: '15%',
      paddingLeft: '1em'
    },
    transportInfo: {
      display: 'flex', 
      alignItems: 'center',
      flex: 1
    },
    lineBusInfo: {
      display: 'flex', 
      width: '85%',
      paddingY: '1em'
    },
    label: {
      fontSize: '1em',
      color: 'black'
    },
    subInfoContainer: {
      display: 'flex',
      width: '100%',
      justifyContent: 'space-between',
      alignItems: 'center'
    },
    sublabel: {
      fontSize: '.85em',
      color: '#3D3D3D',
      fontWeight: 200
    },
    infoContainer: {
      display: 'flex',
      width: '100%'
    },
  };

  const {t} = useTranslation();

  const {transit_info} = properties;
  const {transit_stops, text_color, color, short_name, headsign} = transit_info;

  const renderLabel = () => {
    return (
      <Stack sx={{display: 'flex', alignItems: 'center'}} direction='row' spacing={1}>
        <LabelTransport 
          number={short_name} 
          color={color}
          textColor={text_color}
        />
        <Typography sx={{fontSize: '.85em'}}>
          {headsign ?? 'Inconnu'} 
        </Typography>

      </Stack>
    );
  };

  const renderHour = (hour) => {
    const date = moment(hour);
    return date.format('HH:mm');
  };

  return (
    <Box sx={styles.container}>
      <Stack sx={styles.contentContainer} direction='column' spacing={1}>
        {transit_stops && transit_stops.length > 0 && (
          <Box sx={styles.labelContainer}>
            <Typography sx={styles.label}> 
              {transit_stops[0].name}
            </Typography>
            <Typography sx={styles.label}>
              {renderHour(transit_stops[0].departure_date_time)}
            </Typography>
          </Box>
        )}
        <Box sx={styles.infoContainer}>
          <Box sx={styles.transportContainer}>
            <Box 
              sx={{
                display: 'flex',
                width: '.5em',
                minHeight: '100px',
                borderRadius: '.5em',
                backgroundColor: color,
              }}
            />
          </Box>
          <Box sx={styles.lineBusInfo}>
            <Stack sx={styles.infoContainer} direction='column' spacing={2}>
              <Box sx={{
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'space-between',
              }} 
              >
                {renderLabel()}
              </Box>
              <Box sx={styles.subInfoContainer}>
                {transit_stops && (
                  <Typography sx={styles.sublabel}>
                    {transit_stops.length - 1} {t('transportDetails.stop_label')}
                  </Typography>
                )}
              </Box>
            </Stack>
          </Box>
        </Box>
        {transit_stops && transit_stops.length > 0 && (
          <Box sx={styles.labelContainer}>
            <Typography sx={styles.label}> 
              {transit_stops[transit_stops.length -1].name}
            </Typography>
            <Typography sx={styles.label}>
              {renderHour(transit_stops[transit_stops.length -1].arrival_date_time)}
            </Typography>
          </Box>
        )}
      </Stack>
    </Box>
  );
};